<!-- <button appChangeColorTheme attribute="bgc" class="faQuestionCircle" (click)="openDialogHelp()" disabled [style.opacity]=".4">
  <fa-icon [icon]="getFaIcon('faQuestionCircle')"></fa-icon>
   Aide
</button> -->

<p class="messageHelp">
  Glisser-déposer le(s) stagiaire(s)
</p>
<div cdkDropListGroup cdk-scrollable class="content">

  <div class="list">

    <div class="title_group" appChangeColorTheme attribute="bgc">
      <h3 class="title_list">Stagiaire(s) disponible(s)</h3>
    </div>

    <div class="add_trainee_mobil" (click)="openDialogAddOrEditTrainee('add')">
      <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
      Ajouter un stagiaire
    </div>

    <div class="add_trainee_tablet_desktop" (click)="openDialogAddOrEditTrainee('add')">
      <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
      Ajouter un stagiaire
    </div>

    <div cdkDropList [cdkDropListData]="traineeSelection" [cdkDropListAutoScrollDisabled]="false" class="list_content"
      (cdkDropListDropped)="drop($event, 'stagiaire_inactive')">
      <div class="list_item" *ngFor="let t of traineeSelection" cdkDrag>
        <fa-icon [icon]="getFaIcon('faUser')" appChangeColorTheme attribute="color"></fa-icon>
        <p>{{t.traineeFirstName}} {{t.traineeLastName}}</p>
        <div class="trainee_actions">
          <fa-icon [icon]="getFaIcon('faPen')" (click)="openDialogAddOrEditTrainee('edit', t)" appChangeColorTheme
            attribute="color"></fa-icon>
        </div>

        <div *cdkDragPreview>
          <fa-icon [icon]="getFaIcon('faUser')"></fa-icon>
          {{t.traineeFirstName}} {{t.traineeLastName}}
        </div>
      </div>

    </div>
  </div>
  <div class="list">
    <div class="title_group" appChangeColorTheme attribute="bgc">
      <h3 class="title_list">{{data.offer.traineeQuantity > 1 ? 'Participants' : 'Participant' }}</h3>
      <!-- <span>{{traineeActive?.length}}/{{data.offer.trainees?.length}}</span> -->
      <span>{{traineeActive?.length}}/{{ traineeActive?.length > data.quantity ? traineeActive?.length :
        data.quantity}}</span>
    </div>

    <div cdkDropList [cdkDropListData]="traineeActive" [cdkDropListAutoScrollDisabled]="true"
      class="list_content list_participants" (cdkDropListDropped)="drop($event, 'stagiaire_active')"
      style="--traineeQuantity: {{data.quantity > traineeActive?.length? data.quantity  * 51 : traineeActive?.length * 51 }}px">
      <div class="list_item" *ngFor="let t of traineeActive" cdkDrag>
        <fa-icon [icon]="getFaIcon('faUser')" appChangeColorTheme attribute="color"></fa-icon>
        <p class="traineeLine">
          <fa-icon [icon]="getFaIcon('faInfoCircle')" class="red" *ngIf="t.hasParamsToSet"
            matTooltip="Vous devez remplir les paramètres de ce stagiaire pour finaliser la commande"></fa-icon>
          {{t.traineeFirstName}} {{t.traineeLastName}}
          <ng-container *ngIf="t.parameters?.length > 0 && !t.hasParamsToSet">

            <ng-container *ngIf="t.parameters.length === 1 && !t.hasParamsToSet">
              - <b>{{t.parameters[0].label}} </b> : {{t.parameters[0].selectedValue}}
            </ng-container>

            <fa-icon [icon]="getFaIcon('faInfoCircle')" class="blue" class="parametersValuesIcon"
              *ngIf="t.parameters?.length > 1"></fa-icon>

            <span class="parametersValuesHover">
              <p class="subTitleParameters">Liste des paramètres du stagiaire</p>
              <ul class="parametersList">
                <li *ngFor="let parameter of t.parameters">
                  <b>{{parameter.label}}</b> : {{parameter.selectedValue}}
                </li>
              </ul>
            </span>
          </ng-container>


          <span *ngIf="t.hasParamsToSet" class="hasParamsToSet">
            <br>
            Vous devez remplir les paramètres
          </span>
        </p>
        <div class="trainee_actions">
          <fa-icon [icon]="getFaIcon('faPen')" (click)="openDialogAddOrEditTrainee('edit', t)" appChangeColorTheme
            attribute="color" matTooltip="Modifier les informations du stagiaire"></fa-icon>
        </div>

        <div class="preview" *cdkDragPreview>
          <fa-icon [icon]="getFaIcon('faUser')"></fa-icon>
          {{t.traineeFirstName}} {{t.traineeLastName}}
        </div>
      </div>

      <!-- <p *ngIf="data.quantity !== traineeActive?.length">

        Vous devez
        <span *ngIf="data.quantity - traineeActive?.length > 0">ajouter {{data.quantity - traineeActive?.length}}</span>
        <span *ngIf="data.quantity - traineeActive?.length < 0">retirer {{(data.quantity - traineeActive?.length) * -1}}</span>  stagiaire(s)

        </p> -->

      <div class="no_trainee" *ngIf="!traineeActive?.length">
        Glissez ici les stagiaires que vous souhaitez ajouter à la session.
      </div>
    </div>

    <!-- <p *ngIf="data.offer.traineeQuantity > data.quantity ">Veuillez retirer stagiaire</p> -->

  </div>


</div>

<div class="btn_action" [matTooltipDisabled]="canCloseDialog"
  matTooltip="Il reste des stagiaires avec des paramètres non remplis">
  <!-- <button class="confirm" (click)="traineeActive?.length <= data.quantity ? dialogRef.close(): null" [style.opacity]="traineeActive?.length <= data.quantity ? 1 : .5">Fermer</button> -->
  <button class="confirm" (click)="dialogRef.close()" appChangeColorTheme attribute="bgc" [disabled]="!canCloseDialog"
    [style.opacity]="canCloseDialog ? 1 : .5">Fermer</button>
</div>